<div class="space-y-6">
  <app-page-header
    [backTo]="['/options']"
    backLabel="Retour aux équipements"
    title="Nouvel équipement"
    subtitle="Ajoute une option proposable sur les véhicules (climatisation, GPS, etc.)."
  />

  <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <app-option-form
      mode="create"
      [submitting]="submitting()"
      [serverError]="serverError()"
      (save)="onSave($event)"
      (cancel)="onCancel()"
    />
  </section>
</div>
